import React, { useState } from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { ContactModal } from './ContactModal';
export function TestimonialsSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCTA = () => {
    if (window.innerWidth < 640) {
      window.location.href = 'tel:6025842141';
    } else {
      setIsModalOpen(true);
    }
  };
  const reviews = [{
    name: 'Sarah Jenkins',
    location: 'Phoenix, AZ',
    text: "Absolutely the best service I've ever received. They came out same-day when my AC died in July. Honest pricing and super friendly crew!",
    date: 'August 2023'
  }, {
    name: 'Mike Thompson',
    location: 'Scottsdale, AZ',
    text: 'Old school values are hard to find these days, but these guys have them. No upselling, just fixed the problem. Highly recommend State 48.',
    date: 'September 2023'
  }, {
    name: 'The Rodriguez Family',
    location: 'Mesa, AZ',
    text: "Knowing the owner's story makes me want to support them even more. The work was impeccable and they treated my home with respect.",
    date: 'October 2023'
  }];
  return <>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-232" />
      <section id="reviews" className="py-24 bg-navy relative bg-texture-diagonal" data-id="element-233">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
          <div className="text-center mb-16" data-id="element-235">
            <h2 className="text-4xl md:text-6xl text-cream mb-4" data-id="element-236">
              NEIGHBOR APPROVED
            </h2>
            <p className="text-xl text-blue-200 font-sub uppercase tracking-wide" data-id="element-237">
              Don't just take our word for it
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-238">
            {reviews.map((review, index) => <div key={index} className="bg-tan p-8 rounded-sm shadow-2xl relative" data-id="element-239">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-red-800 shadow-md border-2 border-red-900 z-10" data-id="element-240"></div>
                <div className="absolute top-4 right-4 text-orange/20" data-id="element-241">
                  <QuoteIcon className="h-12 w-12 fill-current transform rotate-180" data-id="element-242" />
                </div>
                <div className="flex text-orange mb-4" data-id="element-243">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-5 w-5 fill-current" data-id="element-244" />)}
                </div>
                <p className="text-brown font-body text-lg mb-6 italic leading-relaxed" data-id="element-245">
                  "{review.text}"
                </p>
                <div className="border-t border-brown/10 pt-4" data-id="element-246">
                  <p className="font-display text-navy text-lg" data-id="element-247">
                    {review.name}
                  </p>
                  <p className="font-sub text-brown/60 text-sm uppercase" data-id="element-248">
                    {review.location} • {review.date}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="text-center mt-12" data-id="element-249">
            <button onClick={handleCTA} className="inline-block border-2 border-orange text-orange hover:bg-orange hover:text-white px-8 py-3 font-sub text-xl uppercase tracking-wide transition-colors rounded-sm cursor-pointer" data-id="element-250">
              Get a Free Quote
            </button>
          </div>
        </div>
      </section>
    </>;
}